import { RuntimeMain } from './runtime/RuntimeMain.js'
import { ComponentLibrary } from './componentLibrary/ComponentLibrary.js'
import { Brand } from 'src/brands/brand';
import * as $ from 'jquery';

export function run_bmi(dialog, params) {

  let componentLibrary = new ComponentLibrary();

  let runtimeMain = new RuntimeMain("#sid-content-runtime-frame", componentLibrary);

  params.bmiName ??= "no-name";
  params.languageCultureName ??= "sv-SE";
  params.brand = Brand.brandName;
  params.showQuestionCounter = Brand.showQuestionCounter;
  params.nextButtonInQuestion = Brand.nextButtonInQuestion;

  params.visitId = "1";
  params.useBootstrapUi = true;
  params.nextButtonDelay = dialog.metadata?.nextButtonDelay ?? 400;
  params.fadeInDelay = dialog.metadata?.fadeInDelay ?? 200;
  params.fadeOutDelay = dialog.metadata?.fadeOutDelay ?? 200;

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    params.fadeInDelay = 0;
    params.fadeOutDelay = 0;
  }
  params.contentUrl = params.contentUrl ?? "assets/dialogs/"

  $(document).ready(function () {
    runtimeMain.run(dialog, params);
  });
}
